export function getHomeRoute() {
    return '/'
}

export function getLoginRoute() {
    return '/logowanie';
}

export function getMapRoute() {
    return '/mapa';
}

export function getWelcomeRoute() {
    return '/powitanie';
}

export function getRulesRoute() {
    return '/zasady';
}

export function getTaskRoute(id: string = ':id') {
    return '/zadanie/' + id;
}

export function getEndRoute() {
    return '/koniec';
}

export function getAddLibraryRoute() {
    return '/admin/addLibrary';
}

export function getEditLibraryRoute(code: string = ':code') {
    return '/edit/' + code;
}

export function getLandingPageRoute(code: string = ':code') {
    return '/l/' + code;
}

export function getLibraryListRoute() {
    return '/admin/list';
}

export function getAdminLoginRoute() {
    return '/admin/login';
}

export function getAdminMainRoute() {
    return '/admin';
}
